/* Tods Planet – product page extras (section: tods-product-extras) */
(function(){
  'use strict';
  var DAY=864e5;

  // A size name as an age range in months: "4 Years" → 48–59, "6-12 Months" → 6–12, "2-3 Y" → 24–47, "18M" → 18–18
  function range(v){
    var t=v.toLowerCase(),n=(t.match(/\d+(\.\d+)?/g)||[]).map(Number);
    if(!n.length)return null;
    var months=/m(o|th|onth)?s?\b|month/.test(t)&&!/y(ea)?r/.test(t);
    var lo=n[0],hi=n.length>1?n[1]:n[0];
    if(months)return [lo,hi];
    return [lo*12,(n.length>1?hi:hi+1)*12-1];
  }
  function ageText(m){
    if(m<1)return 'Newborn';
    if(m<24)return m+' month'+(m>1?'s':'');
    var y=Math.floor(m/12),r=m%12;
    return y+' years'+(r?' '+r+' month'+(r>1?'s':''):'');
  }
  // Working days (Mon–Sat) from today
  function addWorkDays(d,n){d=new Date(d);while(n>0){d=new Date(d.getTime()+DAY);if(d.getDay()!==0)n--}return d}
  function fmt(d){return d.toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short'})}

  function init(root){
    if(root.dataset.ready)return;root.dataset.ready='1';
    var main=document.querySelector('variant-picker')&&document.querySelector('variant-picker').closest('.shopify-section');
    var opt=root.dataset.sizeOption;

    // Arrival dates, shown just under the Add to cart buttons
    var promise=root.querySelector('.tp-promise');
    var eta=root.querySelector('.tp-eta'),now=new Date();
    eta.textContent='Arrives '+fmt(addWorkDays(now,+root.dataset.minDays||3))+' – '+fmt(addWorkDays(now,+root.dataset.maxDays||5));
    var buy=main&&main.querySelector('form[action*="/cart/add"]');
    if(buy){buy.parentNode.insertBefore(promise,buy.nextSibling)}
    promise.hidden=false;

    // Will it fit? The theme redraws its variant picker on every change, so the slider sits just after it (not inside)
    // and the size buttons are looked up afresh each time.
    var fit=root.querySelector('.tp-fit');
    function getSizes(){
      return main?[].slice.call(main.querySelectorAll('variant-picker input[type=radio]')).filter(function(r){return r.dataset.optionName===opt})
        .map(function(r){return {r:r,range:range(r.value)}}).filter(function(x){return x.range}):[];
    }
    var first=getSizes();
    if(fit&&first.length>1){
      var vp=first[0].r.closest('variant-picker');
      vp.parentNode.insertBefore(fit,vp.nextSibling);
      fit.hidden=false;
      var slider=fit.querySelector('.tp-fit-range'),age=fit.querySelector('.tp-fit-age'),out=fit.querySelector('.tp-fit-out');
      // Start the slider at the size that's selected now
      var on=first.filter(function(x){return x.r.checked})[0];
      if(on)slider.value=Math.min(120,on.range[0]);
      var paint=function(){slider.style.setProperty('--p',(slider.value/120*100)+'%')};
      var t=0;
      function pick(){
        var m=+slider.value,sizes=getSizes(),best=null;
        age.textContent=ageText(m);paint();
        if(!sizes.length)return;
        sizes.forEach(function(x){if(!best&&m>=x.range[0]&&m<=x.range[1])best=x});
        if(!best)sizes.forEach(function(x){if(!best&&x.range[0]>=m)best=x});   // between sizes: the next one up
        if(!best){out.innerHTML='Our biggest size here is <b>'+sizes[sizes.length-1].r.value+'</b>, it may be small.';return}
        var value=best.r.value,soldOut=best.r.dataset.optionAvailable==='false',small=m<sizes[0].range[0]&&best===sizes[0];
        out.innerHTML=small?'Our smallest size here is <b>'+value+'</b>, it may be big.'
          :(soldOut?'<b>'+value+'</b> fits best, but it\x27s sold out right now.':'Size <b>'+value+'</b> fits best ✓');
        if(!best.r.checked&&!soldOut){
          clearTimeout(t);
          // the theme then updates price, picture and stock; find the button again in case it was redrawn
          t=setTimeout(function(){var x=getSizes().filter(function(y){return y.r.value===value})[0];if(x&&!x.r.checked)x.r.click()},250);
        }
      }
      slider.addEventListener('input',pick);
      paint();age.textContent=ageText(+slider.value);
    }

    // Sticky Add to cart bar on phones, once the main Add to cart button has scrolled off the top
    var bar=root.querySelector('.tp-bar');
    var addBtn=function(){return main&&main.querySelector('button[name=add]')};
    if(bar&&addBtn()){
      document.body.appendChild(bar);
      var pickEl=bar.querySelector('.tp-bar-pick'),shown=false;
      var label=function(){
        var c=main.querySelector('variant-picker input[type=radio]:checked');
        var price=main.querySelector('.price, [class*=price]');
        pickEl.textContent=[c&&c.value,price&&price.textContent.replace(/\s+/g,' ').replace(/Sale price|Regular price/gi,'').trim().split(' ').slice(-1)[0]].filter(Boolean).join(' · ');
      };
      var set=function(show){
        if(show)label();
        if(show===shown)return;
        shown=show;
        bar.classList.toggle('is-on',show);bar.setAttribute('aria-hidden',show?'false':'true');
        bar.querySelector('button').tabIndex=show?0:-1;
      };
      // Watch the arrival box just under the buttons: the theme redraws the buttons on every variant change, and it
      // scrolls .page-wrapper rather than the window, which an IntersectionObserver handles either way
      var mark=promise.parentNode?promise:addBtn();
      if('IntersectionObserver' in window)new IntersectionObserver(function(es){
        set(!es[0].isIntersecting&&es[0].boundingClientRect.bottom<0);
      }).observe(mark);
      bar.querySelector('.tp-bar-add').addEventListener('click',function(){
        var b=addBtn();if(!b)return;
        if(b.disabled){b.scrollIntoView({behavior:'smooth',block:'center'});return}
        b.click();
      });
    }
  }
  function all(){[].forEach.call(document.querySelectorAll('.tp-root'),init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();
